import { z } from 'zod'
import type { ClientKind } from '@/kinds/kind'
import { invalid } from '@/kinds/kind'
import { useAccess } from '@/state/access'
import { MEMBER_LABEL, SETTINGS_ID, settingsDefaults, settingsSpec, type SettingsSpec } from './schema'

const Nothing = () => null

export const settingsKind: ClientKind<SettingsSpec, Record<string, never>> = {
  name: 'Settings',
  version: 1,
  spec: settingsSpec,
  status: z.object({}),
  // an admin member's record holds her own keys only: the owner's defaults (pushes, blocklist) are not hers to send
  defaults: (spec) => (useAccess.getState().admin ? (spec as SettingsSpec) : settingsDefaults(spec)),
  validate: (r) =>
    r.id === SETTINGS_ID || r.labels[MEMBER_LABEL] ? [] : ['Settings must use the well-known id'],
  initialStatus: () => ({}),
  displayName: () => 'Settings',
  apply: (_r, action) => {
    throw invalid(`Settings has no action ${action}`)
  },
  actions: [],
  ListRow: Nothing,
  Detail: Nothing,
  Form: Nothing,
}

export * from './schema'
